import React, { Component } from "react"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import { loadingStatus, getPayload } from "actions"
import Title from "../general/title"
import _ from 'lodash'
import { Link } from 'react-router-dom'
import FullTable from "components/FullTable"
import helpers from "helpers/helpers"
import Modal from "react-responsive-modal"
import fieldStatus from "helpers/fieldStatus"
import { Formik, Field, Form } from "formik"
import matchModel from "helpers/matchModel"
import submitData from "helpers/submitData"
import * as Yup from "yup"
import ReactSelect from "components/ReactSelect"
import { toast } from "react-toastify"
import lotTypeGroupModel from "models/lotTypeGroup"

class LotTypeManagement extends Component {
	constructor(props) {
		super(props)

		this.state = {
			groupModal: false,
			groupData: _.clone(lotTypeGroupModel),
			columns: [
				{
					Header: "ID",
					accessor: "id",
				},
				{
					Header: "Property",
					accessor: "property",
					filterMethod: (f, r) => helpers.tableText(f, r, "property"),
				},
				{
					Header: "Name",
					accessor: "name",
					filterMethod: (f, r) => helpers.tableText(f, r, "name"),
				},
				{
					Header: "Classification",
					accessor: "classification",
					filterMethod: (f, r) => helpers.tableText(f, r, "classification"),
				},
				{
					Header: "Edit",
					accessor: "edit",
					filterable: false,
				},
			],
			groupColumns: [
				{
					Header: "Property",
					accessor: "property",
					filterMethod: (f, r) => helpers.tableText(f, r, "property"),
				},
				{
					Header: "Name",
					accessor: "name",
					filterMethod: (f, r) => helpers.tableText(f, r, "name"),
				},
				{
					Header: "Lot Types",
					accessor: "lot_types",
					filterMethod: (f, r) => helpers.tableText(f, r, "lot_types"),
				},
				{
					Header: "Edit",
					accessor: "edit",
					filterable: false,
				},
			],
		}
	}

	buildTable = () => {
		let data = []
		_.forEach(this.props.payload.public.lot_types, (v) => {
			if (!this.props.activeProperties.includes(v.property)) {
				return
			}
			let p = {}
			p.name = v.name
			p.id = v.id
			p.classification = v.classification
			let property = _.find(this.props.payload.public.properties, { id: v.property })
			if (property) {
				p.property = property.name
			}
			p.edit = (
				<Link to={`/admin/lot_types/${p.id}`}>
					<i className="far fa-edit"></i>
				</Link>
			)

			data.push(p)
		})
		return data
	}

	buildGroups = () => {
		let ret = []
		_.forEach(this.props.payload.public.lot_type_groups, v => {
			if(v.property == this.props.activeProperties[0]) {
				let property = _.find(this.props.payload.public.properties, {id: v.property})
				let types = ""
				_.forEach(v.children, r => {
					let look = _.find(this.props.payload.public.lot_types, { id: r })
					if(look) types += `${look.name}, `
				})
				types = _.trim(types, ', ')
				ret.push({
					property: property?.name || "",
					name: v.name,
					lot_types: types,
					edit: (
						<a
							onClick={() => {
								this.setState({groupData: v, groupModal: true})
							}}>
							<i className="far fa-edit"></i>
						</a>
					),
				})
			}
		})
		return ret
	}

	onClose = () => {
		this.setState({ groupModal: false })
	}

	buildLotTypes = property => {
		let ret = []
		_.forEach(this.props.payload.public.lot_types, (v) => {
			if (v.property == property) {
				ret.push({ label: v.name, value: v.id })
			}
		})

		return ret
	}

	validation = () => {
		return Yup.object().shape({
			start_date: Yup.number().min(1, "Please choose a start date.").required("Required"),
			expiration: Yup.number().min(1, "Please choose an expiration date.").required("Required"),
			incentive: Yup.string().required("Required"),
			builders: Yup.array()
				.min(1, "Please choose at least one builder.")
				.required()
				.typeError("Please choose at least one builder."),
		})
	}

	render() {
		if (this.props.activeProperties.length !== 1) {
			return (
				<div className="pleaseChoose">
					<h1>Please choose one community to administer.</h1>
				</div>
			)
		} else if (this.props.payloadStatus) {
			return (
				<div className="admin">
					<Title title="Lot Type Management" showDate={false} />
					<div className="content">
						<div className="admin__add">
							<Link to={"/admin/lot_types/add"}>
								<i className="fas fa-plus-circle text-green-600 text-2xl" />
							</Link>
						</div>
						<FullTable
							data={this.buildTable()}
							columns={this.state.columns}
							name="lotTypes"
							title="Lot Types"
							unset={["edit"]}
						/>
						<div className="reportGroup">
							<h3>Lot Type Groups</h3>
							<div className="text-right pb-2">
								<i
									className="fa fa-plus-circle text-green-600 text-2xl cursor-pointer"
									onClick={() => {
										this.setState({ groupData: {} }, () => {
											this.setState({ groupModal: true })
										})
									}}
								/>
							</div>
							<FullTable
								data={this.buildGroups()}
								columns={this.state.groupColumns}
								name="lotTypeGroups"
								title="Lot Type Groups"
								unset={["edit"]}
							/>
						</div>
					</div>
					<Modal
						open={this.state.groupModal}
						onClose={this.onClose}
						center
						classNames={{ modal: "modal__full" }}>
						<h1>Lot Type Group</h1>
						<Formik
							enableReinitialize
							validateOnMount={true}
							validationSchema={Yup.object().shape({
								name: Yup.string().required("Required"),
								property: Yup.number().required("Required"),
								children: Yup.array()
									.min(1, "Please choose at least one lot type.")
									.required('Required')
									.typeError("Please choose at least one lot type."),
							})}
							initialValues={this.state.groupData}
							onSubmit={(values) => {
								try {
									this.props.loadingStatus(true)
									let v = matchModel(_.clone(lotTypeGroupModel), values)
									v.action = "inputLotTypeGroups"
									submitData("mainIngest", v).then((data) => {
										this.props.loadingStatus(false)
										toast.success(data.message)
										this.props.getPayload()
										this.onClose()
									})
								} catch (e) {
									console.log(e)
								}
							}}>
							{(f) => (
								<div className="">
									{/* console.log(f) */}
									<Form>
										<ul className="form__list">
											<li className={fieldStatus("name", f)}>
												<label htmlFor="name">Name</label>
												{f.errors.name && f.touched.name && (
													<div className="form__message">{f.errors.name}</div>
												)}
												<Field
													name={`name`}
													className="form__input"
													value={f.values.name || ""}
												/>
											</li>
											<li className={fieldStatus("property", f)}>
												<label htmlFor="property">
													Property <sup>*</sup>
												</label>
												{f.errors.property && f.touched.property && (
													<div className="form__message">{f.errors.property}</div>
												)}
												<ReactSelect
													name={`property`}
													options={_.map(this.props.payload.public.properties, (v) => {
														return { label: v.name, value: v.id }
													})}
													value={f.values.property}
													onBlur={f.setFieldTouched}
													onChange={f.setFieldValue}
												/>
											</li>
											<li className={fieldStatus("children", f)}>
												<label htmlFor="children">
													Children <sup>*</sup>
												</label>
												{f.errors.children && f.touched.children && (
													<div className="form__message">{f.errors.children}</div>
												)}
												<ReactSelect
													name={`children`}
													options={this.buildLotTypes(f.values.property)}
													value={f.values.children}
													isMulti
													onBlur={f.setFieldTouched}
													onChange={f.setFieldValue}
												/>
											</li>
										</ul>
										<input
											type="submit"
											value="Submit"
											className={helpers.submitClasses(f.isValid)}
										/>
									</Form>
								</div>
							)}
						</Formik>
					</Modal>
				</div>
			)
		} else {
			return ""
		}
	}
}

function mapStateToProps(state) {
	return {
		payload: state.payload,
		payloadStatus: state.payloadStatus,
		activeProperties: state.activeProperties
	}
}

function matchDispatchToProps(dispatch) {
	return bindActionCreators({ loadingStatus, getPayload }, dispatch)
}

export default connect(
    mapStateToProps,
    matchDispatchToProps
)(LotTypeManagement)
